import { create } from "zustand";

export type AlertEventVisibilityType = "all" | "auto"
const VisibilityTypes = ["all", "auto"] as const;

export type AlertSettingsState = {
  eventVisibility: AlertEventVisibilityType;
}

export const useAlertSettingsStore = create(() => {
  const state: AlertSettingsState = {
    eventVisibility: "auto",
  }

  return state;
})

export const AlertSettingsStore = {
  setEventVisibility: (visibility: AlertEventVisibilityType) => {
    useAlertSettingsStore.setState(() => ({
      eventVisibility: visibility,
    }));
  },
  toggleEventVisibility: () => {
    useAlertSettingsStore.setState((state) => ({
      eventVisibility: VisibilityTypes[(VisibilityTypes.indexOf(state.eventVisibility) + 1) % VisibilityTypes.length],
    }));
  },
}